import { render, staticRenderFns } from "./w-colorPicker.vue?vue&type=template&id=75b0ae5a"
import script from "./w-colorPicker.vue?vue&type=script&lang=ts"
export * from "./w-colorPicker.vue?vue&type=script&lang=ts"
import style0 from "./w-colorPicker.vue?vue&type=style&index=0&id=75b0ae5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports